<template>
  <section class="content-block">
    <transition name="slide-fade">
      <div
        v-if="active"
        class="block has-white-background"
      >
        <div
          v-if="eventSequence && (eventSequence !== '1' || eventSequence !== '3')"
          class="inner-block"
        >
          <h3 class="title">
            {{ $t(`startView.special.title`) }}
          </h3>
          <h3 class="title">
            {{ $t(`startView.special.subtitle`) }}
          </h3>
          <button
            class="button is-primary"
            @click="startReservationProcess(3)"
          >
            {{ $t(`startView.special.button`) }}
            <i class="arrow right"/>
          </button>
          <p class="subtitle">
            {{ $t(`startView.special.desc`) }}
          </p>
        </div>
        <template v-else>
          <template v-for="i in 2">
            <!-- set to 3 to enable reservation type #3 -->
            <template v-if="i > 1">
              <div
                class="marker"
                :key="'marker-'+i"
              >
                <div class="line"/>
                <span class="subtitle">{{ $t("general.label.or") }}</span>
              </div>
            </template>
            <div
              class="inner-block"
              :key="'block-'+i"
            >
              <div class="title-container">
                <h3 class="title">
                  {{ $t(`startView.logic${i}.title`) }}
                </h3>
                <InctInfoElement v-if="$t(`startView.logic${i}.tooltip`)">
                  <p
                    class="subtitle"
                    v-html="$t(`startView.logic${i}.tooltip`)"
                  />
                </InctInfoElement>
              </div>
              <h3
                v-if="$t(`startView.logic${i}.subtitle`)"
                class="title"
              >
                {{ $t(`startView.logic${i}.subtitle`) }}
              </h3>
              <button
                class="button is-primary"
                @click="startReservationProcess(i)"
              >
                {{ $t(`startView.logic${i}.button`) }}
                <i class="arrow right"/>
              </button>
              <p
                v-if="$t(`startView.logic${i}.desc`)"
                class="subtitle"
              >
                {{ $t(`startView.logic${i}.desc`) }}
              </p>
            </div>
          </template>
          <div class="marker">
            <div class="line"/>
            <span class="subtitle">{{ $t("general.label.or") }}</span>
          </div>
          <div class="inner-block">
            <div class="title-container">
              <h3 class="title">
                {{ $t(`startView.content.title`) }}
              </h3>
              <InctInfoElement v-if="$t(`startView.content.tooltip`)">
                <p
                  class="subtitle"
                  v-html="$t(`startView.content.tooltip`)"
                />
              </InctInfoElement>
            </div>
            <h3
              v-if="$t(`startView.content.subtitle`)"
              class="title"
            >
              {{ $t(`startView.content.subtitle`) }}
            </h3>
            <button
              class="button is-primary"
              @click="goToPath('sport', true)"
            >
              {{ $t(`startView.content.button`) }}
              <i class="arrow right"/>
            </button>
            <p
              v-if="$t(`startView.content.desc`)"
              class="subtitle"
            >
              {{ $t(`startView.content.desc`) }}
            </p>
          </div>
        </template>
      </div>
    </transition>
  </section>
</template>

<script>
import {getURLParameter} from "../helper";
import InctInfoElement from "@/components/info-element/InctInfoElement.vue";

export default {
  name: 'Start',
  components: {
    InctInfoElement
  },
  data() {
    return {
      active: false,
      showPurchaseButton: false,
      count: 0,
      eventSequence: undefined
    }
  },
  mounted() {

    // for testing:
    // http://localhost:8080/templates/dac/t1/module/reservation/?eventSequence=5 (=7)

    this.eventSequence = this.$store.state.eventSequence = getURLParameter('eventSequence');
    this.active = true;
  },
  methods: {
    startReservationProcess(type) {
      this.$store.state.reservationType = type;
      this.goToPath('fahrt');
    },
    goToPath(route, content = false) {
      if (content) {
        this.$store.state.reservationType = 1;
      }
      this.$router.push(route)
    }
  }
}
</script>

<style scoped lang="scss">
.inner-block {
  display: flex;
  flex-direction: column;
  gap: 5px;

  .subtitle {
    font-size: 12px;
    margin-bottom: 0 !important;
  }
}

.marker {
  width: 100%;
  position: relative;
  display: block;
  text-align: center;
  padding-bottom: 1.6rem;

  .line {
    width: 100%;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }

  .subtitle {
    width: 100px;
    position: absolute;
    top: -0.55rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: block;
    color: rgba(180, 180, 180, 1);
    background-color: rgba(255, 255, 255, 1);
  }
}

@media (max-width: 680px) {
  .marker {
    .subtitle {
      top: -0.35rem;
    }
  }
}
</style>
